module.exports = __webpack_public_path__ + "df544d0720a094654548391ac2133ab4.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/discover.svg
// module id = 416
// module chunks = 0